<!-- desktop menu button in access bar -->
<ng-container *ngIf="menuMode">
  <div id="settings-icon">
    <sh-icon
      button
      icon="settings"
      (click)="drawerVisible = true"
      aria-label="Settings"
    >
    </sh-icon>
    <sh-text size="body-2" color="primary" class="text-setting"
      >Settings</sh-text
    >
  </div>

  <sh-drawer #drawer id="settignsDrawer" position="right">
    <sh-text title size="header-2"
      >Settings
      <sh-icon
        button
        aria-label="Close settings"
        icon="cancel"
        size="s"
        color="secondary"
        (click)="drawerVisible = false"
      ></sh-icon>
    </sh-text>
    <ng-container *ngTemplateOutlet="contents"></ng-container>
  </sh-drawer>
</ng-container>

<!-- mobile view -->
<ng-container *ngIf="!menuMode">
  <div host *ngIf="!modalitySelectorMode">
    <sh-card icon="settings" label="Settings">
      <ng-container *ngTemplateOutlet="contents"></ng-container>
    </sh-card>
  </div>
  <div embedded *ngIf="modalitySelectorMode">
    <div text aria-hidden="true">
      <sh-icon icon="warning"></sh-icon>
      <sh-text size="body-2" color="secondary" style="margin-bottom: 0.5rem">
        Refine your scope of search.<br />(Change this any time in your
        <a href="/settings" (click)="routeService.openSettings()">Settings</a
        >)</sh-text
      >
    </div>

    <ng-container
      *ngTemplateOutlet="modalitySelector; context: { autoApply: true }"
    ></ng-container>
  </div>
</ng-container>

<!-- actual settings panel -->
<ng-template #contents>
  <sh-text size="title-1">Timeline </sh-text>
  <sh-toggle
    id="invertTimelineToggleButton"
    [active]="settingsController.timelineAscending$ | async"
    (active-changed)="onToggleInvertTimeline($event)"
    label="{{ 'label.invertTimeline' | translate }}"
  >
  </sh-toggle>
  <sh-text size="body1" color="secondary" class="timeline-example"
    ><b>Example:</b> {{ sampleDate }}</sh-text
  >
  <sh-divider></sh-divider>

  <sh-text size="title-1">Date Format</sh-text>
  <sh-dropdown [label]="'label.dateFormat' | translate" display="label">
    <sh-menu-item
      *ngFor="let localDateFormat of localDateFormats"
      [active]="
        (settingsController.settings$ | async)?.localDateFormatId ===
        localDateFormat.id
      "
      (active-changed)="onDateFormatChanged($event)"
      [label]="localDateFormat.name + ' (' + localDateFormat.label + ')'"
      [value]="localDateFormat.id"
    ></sh-menu-item>
  </sh-dropdown>

  <sh-divider></sh-divider>

  <sh-text size="title-1">Scope of Search</sh-text>
  <ng-container
    *ngTemplateOutlet="modalitySelector; context: { autoApply: true }"
  ></ng-container>
</ng-template>

<ng-template #modalitySelector let-autoApply="autoApply">
  <api-call-gate [apiCall]="modalities">
    <ng-template #lastSuccessfulData>
      <div class="modalities" role="group" aria-label="Refine scope of search">
        <sh-checkbox
          option
          keyboard-focusable
          [id]="'option-' + m.id"
          role="option"
          color="primary"
          *ngFor="let m of modalitiesWithactiveState$ | async"
          [label]="m.label"
          [attr.aria-label]="m.label"
          [attr.aria-checked]="m.active ? 'true' : 'false'"
          (active-changed)="
            settingsController.onToggleModalityActivation(m.id, $event)
          "
          [active]="m.active"
        ></sh-checkbox>
      </div>
    </ng-template>
  </api-call-gate>
</ng-template>
